module.exports = __webpack_public_path__ + "static/img/边13.6602e9a.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/decorativePainting/imgs/边13.png
// module id = becK
// module chunks = 2